export default function ChatInput({
    input,
    setInput,
    sendMessage,
    isTyping,
    welcome
}) {
    return (
        <div className={`${welcome ? "absolute bottom-0 w-full" : "fixed inset-x-0 bottom-0"} bg-white border-t border-[#cccccc]`}>
            <div className="max-w-3xl mx-auto p-4">
                <div className="flex gap-3">
                    <textarea
                        rows={1}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                sendMessage();
                            }
                        }}
                        disabled={isTyping}
                        placeholder="Enter Your Queries related Re-exams And IPR Trials ... "
                        className="flex-1 bg-white border border-[#bfbfbf] rounded-xl px-5 py-4 resize-none text-black placeholder-gray-600 focus:outline-none focus:border-[#102D33]"
                    />
                    <button
                        onClick={sendMessage}
                        disabled={isTyping || !input.trim()}
                        className="px-6 py-4 rounded-xl text-white bg-[#102D33] hover:bg-[#0A1F23] disabled:opacity-50"
                    >
                        Send
                    </button>
                </div>
                <p className="text-xs text-center text-gray-600 bg-yellow-50 border border-yellow-200 px-4 py-2 mt-2 rounded-lg leading-snug">
                    Disclaimer: This system is in testing. Responses may contain errors.
                    Contact <a href="mailto:ai-admin@wilan.com" className="underline font-medium">ai-admin@wilan.com</a> for support.
                </p>
            </div>
        </div>
    );
}